(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  var toggleBtn = document.querySelector('.search-toggle');
  var closeBtn = document.querySelector('.search-close');
  var searchForm = document.querySelector('.search-form');

  if (toggleBtn && searchForm) {
    toggleBtn.addEventListener('click', function() {
      searchForm.style.display = 'block';
    });
  }

  if (closeBtn && searchForm) {
    closeBtn.addEventListener('click', function() {
      searchForm.style.display = 'none';
    });
  }

  
});
  } catch(e) { console.error(e); }
})();

})();
